import { defaultHttpClient } from '../../httpClient';
import type { ReviewCodiGoodsResponse } from './types';

/**
 * - 리뷰 코디 상품 조회 API
 */
export const getReviewCodiGoods = (reviewSno: number) => {
  return defaultHttpClient
    .request<ReviewCodiGoodsResponse>({
      method: 'GET',
      url: `/webview/reviews/${reviewSno}/codi-goods/`,
    })
    .then(result => result.data);
};